export const strings = {
  emailFormat: 'Invalid email format',
  emailRequired: 'Email is required',
  password: 'Password is required',
  passwordLength: 'Must Contain 6 Characters',
  matchPassword: 'Passwords must match',
  noRecordFound: 'No record found',
}